import { queryOptions, useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import PermissionService from './rolesPermission.service';
import { AxiosResponse } from 'axios';
import { AuthContext } from '@/lib/auth';
import { queryClient } from '@/lib/queryClient';

export interface IPermissions {
  "All-seer": boolean;
  "Customer Administrator": boolean;
  "Customer Manager": boolean;
  "Mass Update Manager": boolean;
  "Notification Author": boolean;
  "Report Executor": boolean;
  "System Manager": boolean;
  "Ticket Assign-other": boolean;
  "Ticket Creator": boolean;
  "Ticket Deleter": boolean;
  "Ticket Editor": boolean;
  "Ticket Mover": boolean;
  "Ticket Staff": boolean;
  "User Manager": boolean;
}

interface IUsePermission {
  permissions: UseQueryResult<IPermissions | null>;
}

export const createPermissionsListQueryOptions = () => {
  const permissionService = PermissionService()

  return queryOptions({
    queryKey: ['permissions-list'],
    queryFn: async () => {
      const response = await permissionService.getPermissionsList({})
      return response?.data
    },
    ...queryClient.defaultQueryOptions,
    enabled: true,
    gcTime: 0,
  })
}

export const createPermissionsQueryOptions = (checkAuthStatus: any) => {

  const isLoggedIn = checkAuthStatus()
  const permissionService = PermissionService()


  return queryOptions({
    queryKey: ['permissions'],
    queryFn: async ({ signal }) => {
      const response = await permissionService.getPermissions({ signal })
      return response?.data
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchInterval: 0,
    refetchOnWindowFocus: false,
    enabled: isLoggedIn,
    gcTime: 0,
    retry: (failureCount, error) => {
      if (!isLoggedIn) return false
      return failureCount < 3
    }

  })
}

export const createRoleIdQueryOptions = (roleid: number) => {
  const permissionService = PermissionService()

  return queryOptions({
    queryKey: ['role-id', roleid],
    queryFn: async () => {
      if (!roleid) return Promise.resolve(null)
      const response = await permissionService.getRoleById({ roleid })
      return response.data
    },
    ...queryClient.defaultQueryOptions,
    enabled: !!roleid,

  })
}

export const createRolesQueryOptions = () => {
  const permissionService = PermissionService()

  return queryOptions({
    queryKey: ['roles'],
    queryFn: async () => {
      const response = await permissionService.getRoles({})
      return response.data || null
    },
    ...queryClient.defaultQueryOptions,
    enabled: true,

  })
}


// export default usePermission;
